import Icon from '../../components/Icon.vue'

Icon.register({"regular/gem":{"width":576,"height":512,"paths":[{"d":"M464 0H112C108 0 104.2 2 102 5.4L2 152.6C-0.9 157-0.6 162.8 2.7 166.8L278.7 507.6C283.5 513.5 292.5 513.5 297.3 507.6L573.3 166.8C576.6 162.7 576.9 157 574 152.6L474.1 5.4C471.8 2 468.1 0 464 0zM444.7 48L508 144H439.6L387.9 48H444.7zM242.6 48H333.3L385 144H191L242.6 48zM131.3 48H188.1L136.4 144H68L131.3 48zM88.3 192H139.7L208 352 88.3 192zM191.2 192H384.8L288 435.3 191.2 192zM368 352L436.2 192H487.6L368 352z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/regular/gem.js
// module id = null
// module chunks = 